// eslint-disable-next-line no-underscore-dangle
export const _selectSortedIds = state => state.mailboxes.sorted
